import { useTranslation } from 'react-i18next';

import { Button } from '@/components/generic';
import { ButtonVariant } from '@/components/generic/Button/button-config';
import { XMarkIcon } from '@/resources';

type SelectionBarProps = {
  selectedCount: number;
  isAllSelected: boolean;
  isDeleting?: boolean;
  onSelectAll: () => void;
  onDelete: () => void;
  onClose: () => void;
};

export const SelectionBar = ({
  selectedCount,
  isAllSelected,
  isDeleting = false,
  onSelectAll,
  onDelete,
  onClose
}: SelectionBarProps) => {
  const [t] = useTranslation('common');

  return (
    <div className='filter-pop-up-shadow fixed bottom-6 left-1/2 z-40 w-[calc(100%-32px)] max-w-[300px] -translate-x-1/2 rounded-2xl bg-primary-white p-3'>
      <div className='flex items-center justify-between border-b border-secondary-blue-gray pb-3'>
        <span className='text-base font-medium text-primary-blue'>
          {selectedCount === 1
            ? t('oneItemSelected')
            : t('itemsSelected', { count: selectedCount })}
        </span>
        <XMarkIcon className='size-4 cursor-pointer text-primary-black' onClick={onClose} />
      </div>
      <div className='mt-3 flex gap-2'>
        <Button
          variant={ButtonVariant.QUATERNARY}
          className='flex-1 !px-2 !text-sm'
          disabled={isAllSelected}
          handleOnClick={onSelectAll}>
          {t('selectAll')}
        </Button>
        <Button
          variant={ButtonVariant.PRIMARY}
          className='flex-1 !bg-accent-red !px-2 !text-sm'
          disabled={isDeleting}
          handleOnClick={onDelete}>
          {t('deleteSelected')}
        </Button>
      </div>
    </div>
  );
};
